import { useEffect } from "react";
import Navbar from "../layouts/nav";
import AnimalInfo from "./info";

export default function AnimalInfoParent(props){
    useEffect(() => {
		// List of JS files to reload
		const jsFiles = [
		  'assets/js/scrolltoTop.js',
		  'assets/js/custom.js',
		];
	
		// Create script elements for each JS file
		jsFiles.forEach((filePath) => {
		  const script = document.createElement('script');
		  script.src = filePath;
		  script.async = true;
		  document.body.appendChild(script);
		});
	
		// Clean up the script elements when the component unmounts
		return () => {
		  jsFiles.forEach((filePath) => {
			const script = document.querySelector(`[src="${filePath}"]`);
			if (script) {
			  document.body.removeChild(script);
			}
		  });
		};
	  }, []);
    return(
        <>
    <Navbar active={'dropdown'}/>
        <AnimalInfo title={props.title} slogan={props.slogan}/>
        </>
    );
}